import React from 'react';
import './Loading.css';

interface LoadingProps {
  message?: string;
  fullHeight?: boolean;
}

const Loading: React.FC<LoadingProps> = ({ 
  message = 'データを読み込み中...', 
  fullHeight = false 
}) => {
  return (
    <div className={`loading-container ${fullHeight ? 'full-height' : ''}`}>
      <div className="loading-spinner"></div>
      <p>{message}</p>
    </div>
  );
};

export default Loading;
